import type { ComponentProps } from "react";
import { linkRestriction } from "../publicAccess";

/** Covers both authored links and links loaded from research data. */
export function PublicLink(props: ComponentProps<"a">) {
  const restriction = linkRestriction(props.href);
  if (!restriction) return <a {...props} />;
  return <span id={props.id} className={[props.className, "unavailable-link"].filter(Boolean).join(" ")} title={restriction.message}>
    {props.children}<small className="link-access-label"> ({restriction.label})</small>
  </span>;
}
